import { useEffect, useRef, useState } from 'react'

export const useLoadRecaptcha = () => {
	const [recaptchaLoaded, setRecaptchaLoaded] = useState(false)
	const recaptchaSrc = `https://www.google.com/recaptcha/enterprise.js?render=${
		process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || ''
	}`
	const scriptAppended = useRef(false)

	useEffect(() => {
		if (recaptchaLoaded) return

		const existingScript = document.querySelector(
			`script[src="${recaptchaSrc}"]`
		) as HTMLScriptElement

		if (existingScript) {
			existingScript.onload = () => setRecaptchaLoaded(true)
			if (window.grecaptcha) {
				setRecaptchaLoaded(true)
			}
			return
		}
		// In order to do not reload the script multiple times
		if (!scriptAppended.current) {
			scriptAppended.current = true
			const script = document.createElement('script')
			script.src = recaptchaSrc
			script.async = true
			script.onload = () => {
				setRecaptchaLoaded(true)
			}
			document.body.appendChild(script)
		}
	}, [recaptchaLoaded, recaptchaSrc])

	return recaptchaLoaded
}
